// Dispatches a global event so ClientLayout can animate a coupon flying into
// the bottom "Coupon" tab and celebrate the saving.
export function triggerCouponFly(sourceEl, label, claimId) {
  let x, y;
  try {
    const r = sourceEl && sourceEl.getBoundingClientRect && sourceEl.getBoundingClientRect();
    if (r) { x = r.left + r.width / 2; y = r.top + r.height / 2; }
  } catch (_) { /* noop */ }
  window.dispatchEvent(new CustomEvent("kn-coupon-claimed", { detail: { x, y, label, claimId } }));
}

// Shows a blocking explanatory dialog when a claim is refused (e.g. anti-abuse suspension).
export function notifyCouponBlocked(message, suspendedUntil) {
  window.dispatchEvent(new CustomEvent("kn-coupon-blocked", { detail: { message, suspendedUntil } }));
}

// Returns true if an axios error is a coupon suspension error (and fires the dialog).
export function handleClaimError(err) {
  const detail = err?.response?.data?.detail;
  if (detail && typeof detail === "object" && detail.code === "coupon_suspended") {
    notifyCouponBlocked(detail.message, detail.suspended_until);
    return true;
  }
  return false;
}
